import React from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import AmountField from 'app/main/components/AmountField';
import AmountAndPercentageField from 'app/main/components/AmountAndPercentageField';
import { formatMoney } from 'app/main/utils/numberUtils';
import clsx from 'clsx';

function deductionFees(props) {
  const { form, classes, deductionTotalAmount, handleChange } = props;

  return (
    <>
      <div className="flex items-center my-20">
        <Typography className={classes.feesTitle} component="h2">
          <b>Deduction fees -</b>
        </Typography>
        <Typography component="h2" className="ml-4">
          <span>
            <b>Total: </b>
          </span>
          {`$ ${formatMoney(deductionTotalAmount, 2)}`}
        </Typography>
      </div>
      <AmountField
        label="Investor Underlining Fee"
        id="deductionFees.investorUnderliningFee"
        className={classes.field}
        value={form.deductionFees.investorUnderliningFee}
        onChange={handleChange}
      />
      <AmountField
        label="Investor Tax Service Fee"
        id="deductionFees.investorTaxServiceFee"
        className={classes.field}
        value={form.deductionFees.investorTaxServiceFee}
        onChange={handleChange}
      />
      <AmountField
        label="Accured Interest"
        id="deductionFees.accuredInterest"
        className={classes.field}
        value={form.deductionFees.accuredInterest}
        onChange={handleChange}
      />
      <TextField
        label="Days Online"
        id="deductionFees.daysOnline"
        name="deductionFees.daysOnline"
        variant="outlined"
        className={clsx(classes.field, 'mt-8 mb-16')}
        value={form.deductionFees.daysOnline}
        onChange={handleChange}
      />
      <AmountField
        label="Warehouse Funding Fee"
        id="deductionFees.warehouseFoundingFee"
        className={classes.field}
        value={form.deductionFees.warehouseFoundingFee}
        onChange={handleChange}
      />
      <AmountField
        label="Reconciliation Report Fee"
        id="deductionFees.reconciliationReportFee"
        className={classes.field}
        value={form.deductionFees.reconciliationReportFee}
        onChange={handleChange}
      />
      <AmountField
        label="Collaterial Dual Fee"
        id="deductionFees.collateralDualFee"
        className={classes.field}
        value={form.deductionFees.collateralDualFee}
        onChange={handleChange}
      />
      <AmountField
        label="Delegated Underlining Fee"
        id="deductionFees.delegatedUnderliningFee"
        className={classes.field}
        value={form.deductionFees.delegatedUnderliningFee}
        onChange={handleChange}
      />
      <AmountAndPercentageField
        label="Loan Officer Concessions"
        id="deductionFees.loanOfficerConcessions"
        className={`${classes.field} ${classes.fieldPercentage}`}
        total={form.loan.loanAmount}
        value={form.deductionFees.loanOfficerConcessions}
        onChange={handleChange}
      />
    </>
  );
}

export default deductionFees;
